import { cn } from "@omni/utils/styles";

import { useResultsPanelContext } from "@/components/Search/SearchBar/components/ResultsPanel/context/resultsPanel.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const NoResults = ({ className }: Props) => {
    const { showResults } = useResultsPanelContext();
    const { t } = useGranite();

    if (showResults) return null;

    return (
        <div className={cn(className)}>{t("searchBox.panel.noResults")}</div>
    );
};
